import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inicializado: false,
  search: '',
};

export const regulatorioFiltroSelector = state => state.regulatorioFiltro;

export const slice = createSlice({
  name: 'regulatorioFiltro',
  initialState,
  reducers: {
    regulatorioFiltroResetar: (state) => {
      return { initialState, inicializado: false };
    },
    regulatorioFiltroAplicar: (state, action) => {
      return { ...state, ...action.payload, inicializado: true, };
    }
  },
  extraReducers: {},
});

export default slice.reducer;

export const { regulatorioFiltroResetar, regulatorioFiltroAplicar } = slice.actions;
